import { createFileRoute, notFound } from "@tanstack/react-router";
import { PrayerSchedulePage } from "@/components/prayer/PrayerSchedulePage";
import { findKecamatan } from "@/data/locations";
import { displayLocationTitle } from "@/lib/prayer/copy";
import { prayerCanonical, prayerJsonLd } from "@/lib/seo/prayer-schema";
import { EmptyLocationState } from "@/components/prayer/EmptyLocationState";
import { SiteShell } from "@/components/layout/SiteShell";

export const Route = createFileRoute("/jadwal-sholat/$kota/$kec")({
  loader: ({ params }) => {
    const loc = findKecamatan(params.kota, params.kec);
    if (!loc) throw notFound();
    return { loc };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { loc } = loaderData;
    const display = displayLocationTitle(loc);
    const title = `Jadwal Sholat ${display} Hari Ini & Sebulan`;
    const desc = `Jadwal sholat ${display}: Imsak, Subuh, Terbit, Dhuha, Dzuhur, Ashar, Maghrib, Isya. Akurat sesuai metode Kemenag RI.`;
    const canonical = prayerCanonical("sholat", loc);
    return {
      meta: [
        { title }, { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: canonical },
        { property: "og:image", content: "https://hari.co.id/og-jadwal-sholat.svg" },
        { property: "og:image:alt", content: `Jadwal Sholat ${display} — hari.co.id` },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: desc },
        { name: "twitter:image", content: "https://hari.co.id/og-jadwal-sholat.svg" },
        { name: "robots", content: "index, follow, max-image-preview:large" },
      ],
      links: [{ rel: "canonical", href: canonical }],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(prayerJsonLd("sholat", loc)) }],
    };
  },
  component: () => {
    const { loc } = Route.useLoaderData();
    return <PrayerSchedulePage variant="sholat" location={loc} />;
  },
  notFoundComponent: () => (
    <SiteShell>
      <EmptyLocationState
        variant="sholat"
        title="Kecamatan tidak ditemukan"
        message="Kombinasi kota dan kecamatan ini belum kami petakan. Silakan cari yang terdekat di indeks lokasi."
      />
    </SiteShell>
  ),
});
